import React from "react";
import { Select } from "antd";
import { EXPLORE_MODES } from "./constants";
import * as _ from "lodash";
const { Option } = Select;

export const ModeSelect = ({ onChange, defaultValue }) => {
  const onSearch = () => {};

  return (
    <div>
      <Select
        size="large"
        defaultValue={defaultValue}
        showSearch
        style={{ width: 200 }}
        placeholder="Select a person"
        optionFilterProp="children"
        onChange={(val) => {
          onChange(val);
        }}
        onSearch={onSearch}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {_.map(EXPLORE_MODES, (r, i) => (
          <Option key={`${r}-${i}`} value={r.value}>
            {r.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};
